import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UltraScale from '../../../Image/UltraScale.png';
import InfoIcon from '@mui/icons-material/Info';

const BntMoreUltraScale = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Componente auxiliar para cada box de informação
  const InfoBox = ({ title, children }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: '#A0C8DF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1.5,
          flexShrink: 0,
        }}
      >
        <CheckCircleIcon sx={{ color: '#F47921', fontSize: 20 }} />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', mb: 1 }}>{title}</Typography>
        <Typography sx={{ ml: 0 }}>{children}</Typography>
      </Box>
    </Box>
  );

  return (
    <div>
      <Button
        size="small"
        onClick={handleClickOpen}
        sx={{
          textTransform: 'none',
          color: '#2b8cb9',
          width: '15%',
          height: '15%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <InfoIcon />
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        sx={{
          '& .MuiDialog-paper': {
            overflow: 'hidden',
            width: '100%',
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 'bold',
            fontFamily: 'Open Sans',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            fontSize: '24px',
          }}
        >
          UltraScale + Computer
        </DialogTitle>

        <DialogContent
          sx={{
            padding: 3,
            overflowY: 'auto',
            maxHeight: '70vh', // Scroll vertical
          }}
        >
          {/* Imagem em cima */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
            <img
              src={UltraScale}
              alt="UltraScale Computer"
              style={{ width: '60%', height: '60%' }}
            />
          </Box>

          {/* Grid com 2 colunas */}
          <Grid container spacing={3}>
            {/* Coluna 1 */}
            <Grid item xs={6}>
              <InfoBox title="Processing Power">
                • Quad-core Arm Cortex-A53 up to 1.5 GHz <br />
                • RTU Dual-core Arm Cortex-R5F up to 600 MHz <br />
                • Programmable Logic 600k System Logic Cells
              </InfoBox>

              <InfoBox title="Data Rate Budgets">
                • Space Wire up to 100 Mbps <br />
                • 1Mbps CAN <br />
                • 1Gb Ethernet
              </InfoBox>

              <InfoBox title="Front Panel Connectivity">
                • 1x Gigabit Ethernet <br />
                • 2x SpaceWire <br />
                • 1x D-Sub 26 Pins with 2x CAN, 1x JTAG and 2x RS-422 UART
              </InfoBox>

              <InfoBox title="Memory">
                • 4GB DDR4 (32 bit) and 256 Mb OctoSPI Flash <br />
                • PS 3GB ECC DDR4 RAM <br />
                • PL 2GB DDR4 <br />
                • PL 192GB NAND Flash (SLC)
              </InfoBox>
            </Grid>

            {/* Coluna 2 */}
            <Grid item xs={6}>
              <InfoBox title="Back Plane Interfaces">
                • 4x Space Wire Mesh <br />
                • 8x Space Wire in Star configuration <br />
                • Custom Supervisor interface for boot memory interface <br />
                • Custom Processor interface (redundancy) <br />
                • ADHA Standard P2 <br />
                • ADHA Standard P1 with CAN, I2C, Sync and GPIOs
              </InfoBox>

              <InfoBox title="Power Budgets">
                • Input Voltage: 12V <br />
                • Maximum Consumption: 15W (peak usage, full processing load with 15% Margin)
              </InfoBox>

              <InfoBox title="Mechanical Budgets">
                • Size: 238.75mm x 112mm x 30.48mm <br />
                • Mass: ~350 grams <br />
                • Thermal: Δt 15,42°C at the processor junction
              </InfoBox>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BntMoreUltraScale;
